var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreHoriz = function SvgMoreHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "more-horiz_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "more-horiz_svg__more-horiz"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2",
    className: "more-horiz_svg__vector"
  }))));
};
export { SvgMoreHoriz as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5Nb3JlIEhvcml6PC90aXRsZT48ZyBjbGFzcz0ibW9yZS1ob3JpeiI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNiAxMGMtMS4xIDAtMiAuOS0yIDJzLjkgMiAyIDIgMi0uOSAyLTItLjktMi0yLTJabTEyIDBjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yWm0tNiAwYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMloiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";